import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { DropdownProps } from ".";
import { ChevronArrowDown, ChevronArrowRight } from "../../../assets/icons";

const Dropdown2: React.FC<DropdownProps> = ({
  options,
  label,
  onSelect,
  placeholder = "Select an option",
  error,
  bgColor,
  dropdownBgColor,
  width,
  selected,
  required,
  showCloseIcon = false,
  showSelectOption = false,
  height = "",
  autoClose = true, // Default to true for backward compatibility
  ...props
}) => {
  return (
    <>
      <Menu
        as="div"
        className={`relative inline-block text-left ${props.className}`}
      >
        <div>
          <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md text-white border-rgba(255, 255, 255, 0.12) bg-primary-500 hover:bg-primary-600 active:text-[#FCFCFD] cursor-pointer px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 h-11 items-center">
            {placeholder}
            <ChevronArrowDown
              aria-hidden="true"
              className="-mr-1 size-5 text-gray-400 mt-[-5px]"
            />
          </MenuButton>
        </div>

        <MenuItems
          transition
          className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md  bg-darkcolor-700 border-[1px] border-darkcolor-400 text-sm font-normal border-solid"
        >
          <div>
            {options?.length > 0 &&
              options.map((x: any) => (
                <MenuItem>
                  <a
                    onClick={() => onSelect(x)}
                    target="_blank"
                    className="cursor-pointer px-4 py-3 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden text-neutral-25 flex justify-between hover:bg-darkcolor-500 hover:border-darkcolor-300 shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                  >
                    {x?.name}
                    <ChevronArrowRight />
                  </a>
                </MenuItem>
              ))}
          </div>
        </MenuItems>
      </Menu>
    </>
  );
};

export default Dropdown2;
